import TokenHandler from 'components/TokenHandler';
import {
  getAccountByToken,
  getConfiguration,
  getRepositories,
  getSensorAuthorizations,
  getOrganization,
  getJobDetails
} from 'state/callers';
import React from 'react';
import { connect } from 'react-redux';
import { dispatchify, recall } from 'common/utils/utils';

import Root from './Root';
import { myAccountSelector } from 'state/selectors/account.js';
import { shouldStopOnboardingRecall } from 'common/services/http-polling-stopper';
import { selectTeamId } from 'state/actions';
import { repositoriesSelector } from 'state/selectors/repositories';

const mapStateToProps = state => {
  const { uiState, organization, sensorAuthorizations, jobs } = state;

  return {
    account: myAccountSelector(state),
    repositories: repositoriesSelector(state),
    uiState,
    organization,
    sensorAuthorizations,
    jobs
  };
};

const mapDispatchToProps = dispatch => ({
  ...dispatchify(dispatch, {
    selectTeamId,
    getAccountByToken,
    getConfiguration,
    getRepositories,
    getSensorAuthorizations,
    getJobDetails
  }),
  ...recall(
    { ...dispatchify(dispatch, { getOrganization }) },
    shouldStopOnboardingRecall,
    20
  )
});

const TokenHandlerHOC = props => (
  <TokenHandler>
    <Root {...props} />
  </TokenHandler>
);

export default connect(mapStateToProps, mapDispatchToProps)(TokenHandlerHOC);
